import { ReactElement, ReactNode } from "react";

/** A coloured outcome notice. */
export const FreeSpinsRetrievalPanel = (props: FreeSpinsRetrievalPanelProps): ReactElement => {
  const { type, children } = props;

  return (
    <div
      className={`fs-retrieval__panel fs-retrieval__panel--${type}`}
      data-testid={`fs-retrieval-${type}`}
    >
      {children}
    </div>
  );
};

interface FreeSpinsRetrievalPanelProps {
  type: "success" | "warning" | "error";
  children: ReactNode;
}
